import { SVGProps } from 'react'

export const MoreVertical = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="4" height="14" fill="none" viewBox="0 0 4 14" {...props}>
    <path
      fill="currentColor"
      d="M2 3.667c.917 0 1.667-.75 1.667-1.667S2.917.333 2 .333.333 1.083.333 2 1.083 3.667 2 3.667zm0 1.667C1.083 5.333.333 6.083.333 7c0 .917.75 1.667 1.667 1.667S3.667 7.917 3.667 7 2.917 5.333 2 5.333zm0 5c-.917 0-1.667.75-1.667 1.666 0 .917.75 1.667 1.667 1.667s1.667-.75 1.667-1.667c0-.916-.75-1.666-1.667-1.666z"
    ></path>
  </svg>
)
